<script setup lang="ts">
  // Components
  import SearchTableRow from './SearchTableRow.vue';
  import SearchResultsTable from './SearchResultsTable.vue';

  // Constants
  import { HEADERS } from '@/features/Search';

  // Interfaces
  import type { DocumentRevision } from '@/entities/Document';
  import type { OrderOptions } from '@/shared/lib';

  defineProps<{
    revisions: DocumentRevision[];
    orderOptions?: OrderOptions[];
    isFilterActive?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'update:sort', sortCamp: string, orderFlow: string): void;
    (e: 'filter-clicked'): void;
  }>();

  const columns = HEADERS.map((text) => ({ text }));

  const handleSortOptions = (sortCamp: string, orderFlow: string) => {
    emit('update:sort', sortCamp, orderFlow);
  };

  const handleFilterClicked = () => {
    emit('filter-clicked');
  };
</script>

<template>
  <SearchResultsTable
    header-text="Registros"
    :columns="columns"
    :row-component="SearchTableRow"
    :revisions="revisions"
    :order-options="orderOptions"
    :is-filter-active="isFilterActive"
    @update:sort="handleSortOptions"
    @filter-clicked="handleFilterClicked"
  />
</template>
